export default __webpack_public_path__ + "10c0cebafc5fd15b8f6cc556f07d4fbc.png";